import {useTranslation} from 'react-i18next';

import {
  getIsSavingPreferences,
  getIsThreeDMapsPreferred,
  updateThreeDMapsPreferred,
  useAppDispatch,
  useAppSelector,
  withAsyncThunkErrorHandling,
} from '@lib/store';

import {Toggle} from '@atoms';
import {ProfileCell} from '../styles';
import {P} from '@quarks';

export const ThreeDMapsToggleCell = () => {
  const {t} = useTranslation('profile');

  const dispatch = useAppDispatch();
  const threeDMapsPreferred = useAppSelector(getIsThreeDMapsPreferred);
  const isSavingPreferences = useAppSelector(getIsSavingPreferences);

  const handleToggle = () => {
    dispatch(withAsyncThunkErrorHandling(() => updateThreeDMapsPreferred(!threeDMapsPreferred)));
  };

  return (
    <ProfileCell>
      <P id="label-threeDMapsToggle">{t('ThreeDMapsToggle')}</P>
      <Toggle
        aria-labelledby="label-threeDMapsToggle"
        data-testid="organisms-profile-CalendarSyncCell_toggle"
        checked={threeDMapsPreferred}
        disabled={isSavingPreferences}
        onChange={handleToggle}
      />
    </ProfileCell>
  );
};
